import React, {useEffect, useState} from "react";
import EmptyTableRow from "../../common/EmptyTableRow";
import useDownloadExcelForm from "./hooks/useDownloadExcelForm";
import useExportRmaListExcel from "./hooks/useExportRmaListExcel";
import useReadRma from "./hooks/useReadRma";
import {BasicSearchType} from "../../../types/common/basic";
import {SubmitHandler, useForm} from "react-hook-form";
import moment from "moment";
import useGoToNavigation from "../../../util/useGotoNavigation";
import {useNavigate, useSearchParams} from "react-router-dom";
import {PaginationMain} from "../../../components/common/pagination/PaginationMain";
import useDeleteRma from "./hooks/useDeleteRma";
import FileUploadNoText from "../../../components/common/fileUpload/fileUploadNoText/FileUploadNoText";
import {useReadOutgoingSerial} from "./hooks/useReadOutgoingSerial";
import {useUploadRmaDetailExcel} from "./hooks/useUploadRmaDetailExcel";
import {outgoingManagementVOType} from "../../../types/support";
import {getJwtPayloadValue} from "../../../util/getJwtPayloadValue";
import {useUser} from "../../../util/userContext/UserContext";
import AuthorityChecker from "../../../components/common/authorityGuard/AuthorityChecker";

export const RmaList = () => {
    const [tab, setTab] = useState<number>(1);
    const {user} = useUser();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [searchData, setSearchData] = useState<BasicSearchType>((() => ({
        endAt: searchParams.get("endAt") || moment(new Date()).format("YYYY-MM-DD"),
        startAt:
            searchParams.get("startAt") ||
            moment(new Date()).subtract(3, "months").format("YYYY-MM-DD"),
        keywordType: searchParams.get("keywordType") || "0",
        limit: 10,
        pageNo: Number(searchParams.get("pageNo")) || 1,
        inOutFlag: getJwtPayloadValue("rmaWriteYn") ? "0" : "1",
        customerId: user?.userId
    }))());

    useEffect(() => {
        if (user) {
            setSearchData({
                endAt: searchParams.get("endAt") || moment().format("YYYY-MM-DD"),
                startAt: searchParams.get("startAt") || moment().subtract(3, "months").format("YYYY-MM-DD"),
                keywordType: searchParams.get("keywordType") || "0",
                limit: 10,
                pageNo: Number(searchParams.get("pageNo")) || 1,
                inOutFlag: getJwtPayloadValue("rmaWriteYn") ? "0" : "1",
                customerId: user.userId,
            });
        }
    }, [user]);

    const {data} = useReadRma({
        searchOption: searchData,
    });
    const {totalCount, rmaList} = data || {totalCount: 0, rmaList: []};

    const {data: serialNoData} = useReadOutgoingSerial({param: searchData})
    const totalCountSerial = serialNoData?.totalCount ?? 0
    const serialList = serialNoData?.outgoingManagementVOList ?? []

    const {mutate: downloadExcelForm} = useDownloadExcelForm();
    const {mutate: downloadExcelListMutate} = useExportRmaListExcel();
    const {mutate: mutateUploadRmaDetailExcel} = useUploadRmaDetailExcel();

    const {register, handleSubmit} = useForm({
        defaultValues: searchData,
    });

    const {goToNavigation} = useGoToNavigation();
    const onSubmit: SubmitHandler<BasicSearchType> = (submitData) => {
        setSearchData(submitData);
        navigate(`?${new URLSearchParams(submitData as any).toString()}`);
    };

    const btnImportExcel = (file: File[]) => {
        const fd = new FormData()
        file.map(el => fd.append("excelFile", el))

        mutateUploadRmaDetailExcel(fd)
    }

    const {
        checkedList,
        addRemovedCheckedList,
        addRemoveCheckedListAll,
        deleteCheckedRma,
    } = useDeleteRma();

    useEffect(() => {
        if (searchParams.get("pageNo")) {
            setSearchData({...searchData, pageNo: Number(searchParams.get("pageNo"))})
        }
    }, [searchParams]);

    useEffect(() => {
        goToNavigation("support/rma/list?pageNo=1", {}, false)
    }, [tab]);

    return (
        <>
            <form className="fiter_wrap mb-0" onSubmit={handleSubmit(onSubmit)}>
                <div className="fiter_top">
                    <h3 className="filter_heading">RMA 검색</h3>
                    <div className="filter_toolbar">
                        <button
                            className="btn btn-info color2 w-170px"
                            onClick={() => {
                                downloadExcelForm();
                            }}
                        >
                            <img
                                src={
                                    process.env.PUBLIC_URL + "/assets/images/icon_download.png"
                                }
                                alt=""
                            />
                            엑셀 양식 다운로드
                        </button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <div className="frm_row search justify-content-start">
                            <label htmlFor="" className="form-label frm_label">
                                상태
                            </label>
                            <select
                                className="form-select w-150px"
                                {...register("keywordType")}
                            >
                                <option value="0">전체</option>
                                <option value="1">접수</option>
                                <option value="2">요청</option>
                                <option value="3">진행</option>
                                <option value="4">종료</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="frm_row">
                            <label htmlFor="" className="form-label frm_label">
                                등록기간
                            </label>
                            <div className="frm_field input_date">
                                <input
                                    type="date"
                                    className="form-control"
                                    max="9999-12-31"
                                    {...register("startAt")}
                                />
                                <span className="txt_range">~</span>
                                <input
                                    type="date"
                                    className="form-control me-0"
                                    max="9999-12-31"
                                    {...register("endAt")}
                                />
                                <button className="btn btn-info btn_search">
                                    <img
                                        src={
                                            process.env.PUBLIC_URL + "/assets/images/icon_search.png"
                                        }
                                        alt=""
                                    />
                                    조회
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>


            <div className="position-relative">
                <div className="mybtns_group">
                    <div className="btn-group" role="group" aria-label="">
                        <button type="button"
                                className={tab == 1 ? "btn btn-light active" : "btn btn-light"}
                                onClick={() => setTab(1)}>RMA
                        </button>
                        <AuthorityChecker authorityNames={['rmaWriteYn']}>
                            <button type="button"
                                    className={tab == 2 ? "btn btn-light active" : "btn btn-light"}
                                    onClick={() => setTab(2)}>Serial No
                            </button>
                        </AuthorityChecker>
                    </div>
                    <div className="mybtns_group_toolbar"></div>
                </div>

                <div className={tab === 1 ? "d-block" : "d-none"}>
                    <div className="content_wrap">
                        <div className="table_top">
                            <h6 className="table_stats">
                                RMA 목록(<span>{totalCount}</span>건)
                            </h6>
                            <div className="table_toolbar">
                                <button
                                    className="btn btn-dark w-150px px-0"
                                    onClick={() => {
                                        downloadExcelListMutate(searchData);
                                    }}
                                >
                                    <img
                                        src={
                                            process.env.PUBLIC_URL + "/assets/images/icon_export.png"
                                        }
                                        alt=""
                                    />
                                    엑셀 내보내기
                                </button>
                                <AuthorityChecker authorityNames={['rmaWriteYn']}>

                                    <button
                                        className="btn btn-success ms-40px px-0"
                                        onClick={() =>
                                            navigate(`${process.env.PUBLIC_URL}/support/rma/create`)
                                        }
                                    >
                                        RMA 생성
                                    </button>
                                </AuthorityChecker>
                                <AuthorityChecker authorityNames={['rmaWriteYn']}>
                                    <button
                                        className="btn btn-outline-success px-0"
                                        onClick={deleteCheckedRma}
                                    >
                                        RMA 삭제
                                    </button>
                                </AuthorityChecker>
                            </div>
                        </div>
                        {/* 내부수정: table_scroll 삭제 */}               
                        <table className="table table-bordered my_table">
                            <thead>
                            <tr>
                                <AuthorityChecker authorityNames={['rmaWriteYn']}>
                                    <th rowSpan={2} style={{width: "4.4%"}}>
                                        <div className="checkbox_outer">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                checked={checkedList.length === rmaList.length && rmaList.length !== 0}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    const arr = rmaList.map((item) => item.rmaId);
                                                    addRemoveCheckedListAll(arr);
                                                }}
                                            />
                                        </div>
                                    </th>
                                </AuthorityChecker>
                                <th style={{width: "11.94%"}} rowSpan={2}>
                                    RMA 일자
                                </th>
                                <th style={{width: "11.94%"}} rowSpan={2}>
                                    담당자
                                </th>
                                <th style={{width: "23.89%"}} colSpan={2}>
                                    고객
                                </th>
                                <th style={{width: "11.94%"}} rowSpan={2}>
                                    규격
                                </th>
                                <th style={{width: "11.94%"}} rowSpan={2}>
                                    COA구분
                                </th>
                                <th style={{width: "11.94%"}} rowSpan={2}>
                                    수량
                                </th>
                                <th rowSpan={2}>상태</th>
                            </tr>
                            <tr>
                                <th style={{width: "11.94%"}}>거래처</th>
                                <th style={{width: "11.94%"}}>연락처</th>
                            </tr>
                            </thead>
                            <tbody>
                            {totalCount === 0 ? (
                                <EmptyTableRow colSpan={9}/>
                            ) : (
                                rmaList.map((item) => (
                                    <tr
                                        className={checkedList.includes(item.rmaId) ? "lightblue clickable" : "clickable"}
                                        onClick={() => {
                                            goToNavigation(
                                                "support/rma/detail/" + item?.rmaId,
                                                {},
                                                false
                                            );
                                        }}
                                    >
                                        <AuthorityChecker authorityNames={['rmaWriteYn']}>
                                            <td className="text-center">
                                                <div className="checkbox_outer">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        checked={checkedList.includes(item.rmaId)}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            addRemovedCheckedList(item.rmaId);
                                                        }}
                                                    />
                                                </div>
                                            </td>
                                        </AuthorityChecker>
                                        <td className="text-center">{item?.rmaAt}</td>
                                        <td className="text-center">{item?.handlerName}</td>
                                        <td className="text-center">
                                            {item?.customerCompanyName}
                                        </td>
                                        <td className="text-center">{item?.customerAlias}</td>
                                        <td className="text-center">{item?.newTxtStndItem}</td>
                                        <td className="text-center">{item?.coa}</td>
                                        <td className="text-end">{item?.quantity}</td>
                                        <td className="text-center">{item?.questionState}</td>
                                    </tr>
                                ))
                            )}
                            </tbody>
                        </table>

                        <PaginationMain totalCount={totalCount ?? 0}/>
                    </div>
                </div>

                <div className={tab === 2 ? "d-block" : "d-none"}>
                    <div className="content_wrap">
                        <div className="table_top">
                            <h6 className="table_stats">출고 Serial No 목록 (<span>{totalCountSerial}</span>건)</h6>
                            <div className="table_toolbar">
                                <FileUploadNoText
                                    addFileCallback={(file: File[]) => btnImportExcel(file)}
                                    customRenderer={(onClick: any, disabled: any) =>
                                        <button className="btn btn-outline-dark w-150px px-0"
                                                onClick={onClick}
                                                disabled={disabled}><img
                                            src={process.env.PUBLIC_URL + "/assets/images/icon_import.png"} alt=""/>엑셀
                                            가져오기
                                        </button>

                                    }
                                    accept={".xlsx, .xls"}
                                />
                            </div>
                        </div>

                        <div className="table_scroll">
                            <table className="table table-bordered my_table">
                                <thead>
                                <tr>
                                    <th style={{width: "6%"}}>거래처 코드</th>
                                    <th style={{width: "10%"}}>출고업체명</th>
                                    <th style={{width: "8%"}}>규격</th>
                                    <th style={{width: "8%"}}>SN(start1)</th>
                                    <th style={{width: "8%"}}>SN(end1)</th>
                                    <th style={{width: "8%"}}>SN(start2)</th>
                                    <th style={{width: "8%"}}>SN(end2)</th>
                                    <th style={{width: "8%"}}>SN(start3)</th>
                                    <th style={{width: "8%"}}>SN(end3)</th>
                                    <th style={{width: "8%"}}>출고일</th>
                                    <th style={{width: "8%"}}>파일명</th>
                                    <th style={{width: "4%"}}>QTY</th>
                                    <th>비고</th>
                                </tr>
                                </thead>
                                <tbody>
                                {serialList.length !== 0
                                    ? serialList.map((el: outgoingManagementVOType) => <tr>
                                        <td className="text-center">{el.accountCode}</td>
                                        <td className="text-center">{el.outgoingAccountName}</td>
                                        <td className="text-center">{el.newTxtStndItem}</td>
                                        <td className="text-center">{el.serialNoStart1}</td>
                                        <td className="text-center">{el.serialNoEnd1}</td>
                                        <td className="text-center">{el.serialNoStart2}</td>
                                        <td className="text-center">{el.serialNoEnd2}</td>
                                        <td className="text-center">{el.serialNoStart3}</td>
                                        <td className="text-center">{el.serialNoEnd3}</td>
                                        <td className="text-center">{moment(el.outgoingDate).isValid() ? moment(el.outgoingDate).format("YYYY-MM-DD") : ""}</td>
                                        <td className="text-center">{el.fileName}</td>
                                        <td className="text-center">{el.qty}</td>
                                        <td>{el.remark}</td>
                                    </tr>)
                                    : <EmptyTableRow colSpan={13}/>
                                }
                                </tbody>
                            </table>
                        </div>
                        <PaginationMain totalCount={totalCountSerial ?? 0}/>
                    </div>
                </div>
            </div>

        </>
    );
};
